import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-version-menu',
  templateUrl: './version-menu.component.html',
  styleUrls: ['./version-menu.component.scss'],
})
export class VersionMenuComponent implements OnInit {
  public versions = [
    {
      version: 'V.4',
      url: 'https://cdn.www.gov.co/v4/',
    },
    {
      version: 'V.3 (No Vigente)',
      url: 'https://cdn.www.gov.co/v3/',
    },
    {
      version: 'V.2 (No Vigente)',
      url: 'https://cdn.www.gov.co/v2/',
    },
    {
      version: 'V.1 (No Vigente)',
      url: 'https://cdn.www.gov.co/',
    },
  ];

  constructor() {
    //Empty Function
  }

  ngOnInit(): void {
    //Empty Function
  }
}
